module.exports = "/_next/static/images/16-1-746605f8740fff1003379201e50fb430.svg";